var React = require('react');

function Direction45 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M88.375 12.625L4.20837 48.6964L38.8652 62.1348L52.3036 96.7917L88.375 12.625ZM52.6933 74.5158L45.3702 55.6298L26.4841 48.3067L72.3502 28.6498L52.6933 74.5158Z","fill":"#056839"}));
}

Direction45.defaultProps = {"width":"101","height":"101","viewBox":"0 0 101 101","fill":"none"};

module.exports = Direction45;

Direction45.default = Direction45;
